/**
 * Uses Greensock and ScrollMagic. We are already using this for the section aware
 * scrollToAnchors.js so it made sense to leverage here
 */

let ScrollMagic = require('scrollmagic');
require('scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap').default;
require('scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators');

import $ from 'jquery';

const selectors = { 
	stickyNav: '.js-sticky-nav'
};

const $el = {
	pinSpacer: $('.scrollmagic-pin-spacer'),
	topBar: $('.c-top-bar'),
	topNav: $('.c-top-nav')
};

let vars = {
	scrollOffset: 0,
	scene: null,
	controller: null
};

export default function init() {
	if ($(window).width() > 767 && !Modernizr.touch && $(selectors.stickyNav).length) {
	
		stickyNav();
		
	} else if (vars.controller) {
		// If there is a controller active and we're on mobile, destroy it
		vars.controller.destroy(true);
		vars.controller = null;
		vars.scene.destroy(true);
	}
}

// function getScrollOffset() {
// 	if ($(window).width() > 991) {
// 		return $el.topBar.outerHeight() + $el.topNav.outerHeight();
// 	}
// 	
// 	return $el.topBar.outerHeight();
// }

// SCrollmagic doesn't calculate this properly
function updatePinHeight() {
	$('.scrollmagic-pin-spacer').css('minHeight', $(selectors.stickyNav).outerHeight());
}

function stickyNav() {
	
	// vars.scrollOffset = getScrollOffset();
	
	// If there is a controller active, update some options
	if (vars.controller) {
		// vars.scene.offset(-vars.scrollOffset);
		updatePinHeight();
		return;
	}
	
	// Initialise the ScrollMagic controller
	vars.controller = new ScrollMagic.Controller();
	
	// When the sticky nav reaches the nav, stick it
	vars.scene = new ScrollMagic.Scene({
		triggerHook: 'onLeave',
		triggerElement: selectors.stickyNav
	})
	// .addIndicators({ name: 'stickyNav' })
	.setPin(selectors.stickyNav, {
		pushFollowers: false
	})
	// .offset(-vars.scrollOffset)
	.setClassToggle(selectors.stickyNav, 'is-stuck')
	.addTo(vars.controller);

}

export function resize() {
	init();
}
